import { useEffect, useState } from 'react';

/** Delay used for search inputs: long enough to skip mid-word keystrokes. */
export const SEARCH_DEBOUNCE_MS = 300;

/**
 * Returns `value` once it has stopped changing for `delay` ms, so typing in a
 * search box fires one request when the user pauses instead of one per key.
 */
export function useDebouncedValue<T>(value: T, delay = SEARCH_DEBOUNCE_MS): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => setDebounced(value), delay);

    return () => window.clearTimeout(timeoutId);
  }, [value, delay]);

  return debounced;
}
